var _desc, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrochette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Brochette") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.978 1.998V12m0 40v10.002m0-34.002v7.871m-32-33.873V12m0 40v10.002m0-34.002v7.871m10.925 7.49a2.001 2.001 0 0 0-2.79.461 10.002 10.002 0 0 1-16.2.086 2 2 0 1 0-3.226 2.367 14.002 14.002 0 0 0 22.675-.123 1.999 1.999 0 0 0-.459-2.79zm31.963-24a2 2 0 0 0-2.79.46 10 10 0 0 1-16.201.087 2 2 0 0 0-3.226 2.365 14 14 0 0 0 22.676-.12 1.999 1.999 0 0 0-.459-2.792zm-31.963 0a2 2 0 0 0-2.79.46 10 10 0 0 1-16.2.087 2 2 0 0 0-3.226 2.365 14 14 0 0 0 22.675-.12 1.999 1.999 0 0 0-.459-2.792zm31.963 24a2.001 2.001 0 0 0-2.79.461 10.002 10.002 0 0 1-16.201.086 2 2 0 1 0-3.226 2.367 14.002 14.002 0 0 0 22.676-.123 1.999 1.999 0 0 0-.459-2.79z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    "data-name": "layer2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M55.978 16a4 4 0 0 1-4 4h-8.002a4 4 0 0 1-4-4 4 4 0 0 1 4-4h8.002a4 4 0 0 1 4 4zm-32 24a4 4 0 0 1-4 4h-8.002a4 4 0 0 1-4-4 4 4 0 0 1 4-4h8.002a4 4 0 0 1 4 4zm32 0a4 4 0 0 1-4 4h-8.002a4 4 0 0 1-4-4 4 4 0 0 1 4-4h8.002a4 4 0 0 1 4 4zm-32-24a4 4 0 0 1-4 4h-8.002a4 4 0 0 1-4-4 4 4 0 0 1 4-4h8.002a4 4 0 0 1 4 4z",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrochette);
export default __webpack_public_path__ + "static/media/brochette.5c79f39b.svg";
export { ForwardRef as ReactComponent };